import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { HOME_CONTENT_WIDGET_ACTION_TYPE } from "./home-content-widget.action";
import { HomeContentWidgetState } from "./home-content-widget.model";

const INITIAL_STATE: HomeContentWidgetState = {
	content: [],
};

export function homeContentWidgetReducer(state = INITIAL_STATE, action: ActionWithPayload): HomeContentWidgetState {
	switch (action.type) {
		case HOME_CONTENT_WIDGET_ACTION_TYPE.getSuccess: {
			return updateState(state, {
				content: action.payload,
			});
		}
		default:
			return state;
	}
}
